import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
} from '@chakra-ui/modal'
import { Button, Flex, Text, useDisclosure } from '@chakra-ui/react'
import { FlowChart } from './FlowChart'
import { formatDate } from '../../../utils/formatDate'

export const ModalInfoRodizio = ({ rodizio }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <>
      <Button color="gray.700" fontWeight="bold" onClick={onOpen}>
        Por que entrou no rodízio?
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{rodizio.numero_unico}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex flexDir="column" gap={2}>
              <Text color="gray.500" fontWeight="bold">
                Data da entrada do cliente:{' '}
                {rodizio.data_entrada && formatDate(rodizio.data_entrada)}
              </Text>
              <Text color="gray.500" fontWeight="bold">
                Quando entrou no fluxo:{' '}
                {rodizio.data_controle && formatDate(rodizio.data_controle)}
              </Text>
              <Text color="gray.500" fontWeight="bold">
                Vendedor no momento do rodízio:{' '}
                {rodizio.nome_vendedor && rodizio.nome_vendedor}
              </Text>
            </Flex>
            <FlowChart rodizio={rodizio} />
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
